// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__jWZdr","footer":"ModalUpdate_footer__2BFbD"};